module.exports = __webpack_public_path__ + "static/us-3945c5188121e9aadfea31b377651d95.svg";